import React, { useState } from 'react';

import newsletter from './assets/newsletter.png';
import style from './NewsletterCard.module.less';

import { NewsletterModal } from '../NewsletterModal';

interface NewsletterCardProps {
  alternate?: boolean;
  tags?: string[]; // location on the website, will be added as a tag on Mailchimp. Will help identify sign up form
}

export const NewsletterCard: React.FC<NewsletterCardProps> = (props) => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <>
      <div className={style.newsletterCard}>
        <div className={style.wrapper}>
          <div className={style.buttonWrapper}>
            <a onClick={() => setModalVisible(true)}  className={style.button}>
              <div className={style.buttonContent}>
                <div>
                  <img src={newsletter} alt="newsletter" />
                </div>
                <div className={style.text}>
                  Join our Newsletter
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <NewsletterModal isOpen={modalVisible} onClose={() => setModalVisible(false)} tags={props.tags} />
    </>
  );
};
